import { LegacyVisibilityModel, ColumnVisibilityModelsType } from './columns/shared/column-types';
import { validateView } from './columns/shared/column-utils';
import { Views } from './columns/views';
import {
  buildVisibilityModel,
  getByViewTab,
  getByMappingName,
} from './columns/legacy/columnVisibilityAdapter';

function splitIdents(idents: string, searchType: string): string[] {
  return searchType === 'CHEMICALS' ? idents.split(/(?<=\d)-(?=C)/) : idents.split('-');
}

function applyDynamicColumnLogic(
  viewName: string,
  model: LegacyVisibilityModel,
  searchItems?: any[],
  urlIdents?: string,
  urlView?: string,
): LegacyVisibilityModel {
  let view: string | null = null;
  let identCount = 0;

  if (searchItems && searchItems.length > 0) {
    identCount = searchItems.length;
    if (viewName.includes('DISEASES')) {
      view = 'DISEASES';
    } else if (viewName.includes('GENES')) {
      view = 'GENES';
    } else if (viewName.includes('VARIANTS')) {
      view = 'VARIANTS';
    } else if (urlView) {
      view = urlView;
    }
  } else if (urlIdents && urlView) {
    view = urlView;
    const identArray = splitIdents(urlIdents, urlView);
    identCount = identArray.length;
  } else {
    const urlParams = new URLSearchParams(window.location.search);
    const idents = urlParams.get('idents');
    view = urlParams.get('view');

    if (idents && view) {
      const identArray = splitIdents(idents, view);
      identCount = identArray.length;
    }
  }

  if (viewName === 'DISEASES_GDA_SUMMARY') {
    if (view === 'DISEASES' && identCount > 0) {
      if (identCount === 1) {
        return {
          ...model,
          diseaseName: false,
        };
      }
    }
    return model;
  }

  if (viewName === 'GENES_GDA_SUMMARY') {
    if (view === 'GENES' && identCount > 0 && model.geneSymbol === true) {
      if (identCount === 1) {
        return {
          ...model,
          geneSymbol: false,
        };
      }
    }
    return model;
  }

  if (viewName === 'GENES_VDA_SUMMARY') {
    if (view === 'GENES' && identCount > 0 && model.geneSymbol === true) {
      if (identCount === 1) {
        return {
          ...model,
          geneSymbol: false,
        };
      }
    }
    return model;
  }

  if (viewName === 'VARIANTS_VDA_SUMMARY') {
    if (view === 'VARIANTS' && identCount > 0 && model.variantStrID === true) {
      if (identCount === 1) {
        return {
          ...model,
          variantStrID: false,
        };
      }
    }
    return model;
  }

  if (viewName === 'VARIANTS_VDA_EVIDENCE') {
    if (view === 'VARIANTS' && identCount > 0 && model.variantStrID === true) {
      if (identCount === 1) {
        return {
          ...model,
          variantStrID: false,
        };
      }
    }
    return model;
  }

  if (viewName === 'VARIANTS_ALL') {
    if (view === 'VARIANTS' && identCount > 0 && model.strID === true) {
      if (identCount === 1) {
        return {
          ...model,
          strID: false,
        };
      }
    }
    return model;
  }

  return model;
}

const ColumnVisibilityModels: ColumnVisibilityModelsType = {} as ColumnVisibilityModelsType;

Object.entries(Views).forEach(([viewName, viewModel]) => {
  try {
    validateView(viewModel);
    const baseModel = buildVisibilityModel(viewModel);
    ColumnVisibilityModels[viewName] = baseModel;
  } catch (error) {
    throw error;
  }
});

ColumnVisibilityModels['numberPmidsWithChemsIncludedInEvidenceGDA_EVIDENCE'] =
  ColumnVisibilityModels['GDA_ALL_EVIDENCE'];
ColumnVisibilityModels['numberPmidsWithChemsIncludedInEvidenceVDA_EVIDENCE'] =
  ColumnVisibilityModels['VDA_ALL_EVIDENCE'];
ColumnVisibilityModels['numPMIDsupportingAssociationGDA_EVIDENCE'] =
  ColumnVisibilityModels['GDA_ALL_EVIDENCE'];
ColumnVisibilityModels['numPMIDsupportingAssociationVDA_EVIDENCE'] =
  ColumnVisibilityModels['VDA_ALL_EVIDENCE'];

Object.defineProperty(ColumnVisibilityModels, 'getByViewTab', {
  value: function (
    VIEW: string,
    TAB: string,
    isEvidence: boolean,
    searchItems?: any[],
    urlIdents?: string,
    urlView?: string,
  ): LegacyVisibilityModel | undefined {
    const baseModel = getByViewTab(this, VIEW, TAB, isEvidence);
    if (!baseModel) return undefined;

    const viewType = isEvidence ? 'EVIDENCE' : 'SUMMARY';
    const expectedKey = `${VIEW}_${TAB}_${viewType}`;
    return applyDynamicColumnLogic(expectedKey, baseModel, searchItems, urlIdents, urlView);
  },
  enumerable: false,
});

Object.defineProperty(ColumnVisibilityModels, 'getByMappingName', {
  value: function (mappingName: string, isEvidence: boolean): LegacyVisibilityModel | undefined {
    return getByMappingName(this, mappingName, isEvidence);
  },
  enumerable: false,
});

export { ColumnVisibilityModels, Views };
export { buildVisibilityModel } from './columns/legacy/columnVisibilityAdapter';
export { validateView } from './columns/shared/column-utils';
export type {
  ColumnViewModel,
  LegacyVisibilityModel,
  ColumnVisibilityModelsType,
} from './columns/shared/column-types';
